<template>
  <div class="week-calendar">
    <div class="switch-date-bar">
      <i class="icon-chevron-back" />
      <p>2020.04.08</p>
      <i class="icon-chevron-forward" />
    </div>
    <div class="dates">
      <div class="date">
        <p class="blue">
          日
        </p>
        <div class="num">
          <p>5</p>
        </div>
      </div>
      <div class="date">
        <p class="blue">
          一
        </p>
        <div class="num">
          <p>5</p>
        </div>
      </div>
      <div class="date">
        <p class="blue">
          二
        </p>
        <div class="num today ">
          <p>5</p>
        </div>
      </div>
      <div class="date">
        <p class="blue">
          三
        </p>
        <div class="num">
          <p>5</p>
        </div>
      </div>
      <div class="date">
        <p class="blue">
          四
        </p>
        <div class="num">
          <p>5</p>
        </div>
      </div>
      <div class="date">
        <p class="blue">
          五
        </p>
        <div class="num active">
          <p>5</p>
        </div>
      </div>
      <div class="date">
        <p class="blue">
          六
        </p>
        <div class="num">
          <p>5</p>
        </div>
      </div>
    </div>
    <div class="schedule-wrap">
      <p class="blue">
        行程
      </p>
      <div
        v-if="schedule"
        class="schedule-list"
      >
        <div class="schedule-item">
          <i class="icon-nav-event-outline" />
          <div class="item-content">
            <p>外部查廠</p>
            <p class="time">
              08:00
            </p>
          </div>
        </div>
        <div class="schedule-item">
          <i class="icon-nav-event-outline" />
          <div class="item-content">
            <p>外部查廠外部查廠外部查廠</p>
            <p class="time">
              08:00
            </p>
          </div>
        </div>
        <div class="schedule-item">
          <i class="icon-nav-event-outline" />
          <div class="item-content">
            <p>外部查廠</p>
            <p class="time">
              08:00
            </p>
          </div>
        </div>
      </div>
      <p
        v-else
        class="gray"
      >
        這天沒有行程
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "WeekCalendar",
  data: () => ({
    schedule: true,
  }),
};
</script>
<style lang="scss" scoped>
.week-calendar {
  width: 100%;
  .switch-date-bar {
    @include flex_align;
    justify-content: space-between;
    i {
      font-size: 1.5rem;
      color: #0585d3;
      cursor: pointer;
    }
    p {
      font-size: 0.875rem;
      font-weight: bold;
      line-height: 1.43;
      letter-spacing: 1px;
      color: #0585d3;
    }
  }
  .dates {
    @include auto_margin_top(8px);
    @include flex;
    justify-content: space-between;
    .date {
      width: calc(100% / 7);
      p {
        font-size: 0.875rem;
        font-weight: bold;
        line-height: 1.43;
        letter-spacing: 1px;
        text-align: center;
        color: #373737;
        &.blue {
          color: #0585d3;
        }
      }
      .num {
        @include auto_margin_top(9px);
        position: relative;
        cursor: pointer;
        p {
          position: relative;
          z-index: 2;
        }
        &::after {
          content: "";
          display: block;
          position: absolute;
          z-index: 1;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 30px;
          background-color: transparent;
          border-radius: 50%;
        }
        &.today {
          p {
            color: #0585d3;
          }
        }
        &:hover {
          &::after {
            background-color: #a1d3f9;
          }
        }
        &:active {
          &::after {
            background-color: #0585d3;
          }
        }
        &.active {
          p {
            color: #ffffff;
          }
          &::after {
            background-color: #0585d3;
          }
        }
      }
    }
  }
  .schedule-wrap {
    @include auto_margin_top(24px);
    padding: 20px;
    min-height: 108px;
    border-radius: 20px;
    background-color: #ffffff;
    p {
      font-size: 0.875rem;
      line-height: 1.43;
      letter-spacing: 1px;
      &.blue {
        font-weight: bold;
        color: #0585d3;
      }
      &.gray {
        @include auto_margin_top(8px);
        text-align: center;
        color: #808080;
      }
    }
    .schedule-list {
      width: 100%;
      .schedule-item {
        @include flex_align;
        &:first-child {
          .item-content {
            border-top: none;
          }
        }
        i {
          font-size: 1.5rem;
          color: #808080;
        }
        .item-content {
          @include auto_margin_left(8px);
          @include flex_align;
          justify-content: space-between;
          padding: 16px 0;
          width: 100%;
          border-top: 1px solid #a1d3f9;
          p {
            font-size: 1rem;
            font-weight: bold;
            line-height: 1.38;
            letter-spacing: 1px;
            color: #808080;
            &.time {
              @include auto_margin_left(10px);
              font-size: 0.75rem;
              font-weight: normal;
              line-height: 1.5;
              letter-spacing: 0.8px;
            }
          }
        }
      }
    }
  }
}
</style>